import React from 'react';
import ChatLayoutV2 from './ChatLayoutV2';

export { CHAT_V2_SIDEBAR_COLLAPSED_KEY } from './ChatLayoutV2';

export default function ChatLayout(props) {
  return <ChatLayoutV2 {...props} />;
}
